import { useDispatch } from 'react-redux';
import useApplicationFundingData from './useApplicationFundingData';
import {
  applicationFunding,
  updateApplicationFunding,
} from '../store/actions/funding/fundingActions';
import useApplicationUid from './useApplicationUid';
import { parseEnumType } from '../util/helpers/enumMappers';
import { APPLICATION_FUNDING_TYPE } from '../util/constants';

const useApplicationFundingDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationFunding } = useApplicationFundingData();
  const { ApplicationUid } = useApplicationUid();

  const applicationFundingDispatch = ({ data, onSuccess, onError }) => {
    const bankFundingType = parseEnumType(
      APPLICATION_FUNDING_TYPE,
      ApplicationFunding?.BankFundingType,
    );

    const shouldSkip = bankFundingType === data.BankFundingType;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (ApplicationFunding) {
      dispatch(
        updateApplicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        applicationFunding({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { applicationFundingDispatch };
};

export default useApplicationFundingDispatch;
